export { multisitePlugin } from 'src/lib/extract-path/plugins/multisite';
export { personalizePlugin } from 'src/lib/extract-path/plugins/personalize';
